import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { newAuthService } from "Service/Axios";
import { createContactUsUrl } from "Constant/api";
import { Validator } from "Utils/validator";

export const ContactSales = ({ show, toggle }) => {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    fullName: "",
    organizationName: "",
    phone: "",
    country: "",
    reason: "",
    email: "",
  });
  const [errors, setErrors] = useState({
    fullName: "",
    organizationName: "",
    phone: "",
    country: "",
    reason: "",
    email: "",
  });

  const { fullName, organizationName, phone, country, reason, email } =
    formData;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "fullName") {
      if (!Validator.text(value)) {
        setErrors((prev) => ({
          ...prev,
          fullName: t("common.messages.error.common.fullName.blank"),
        }));
      } else if (Validator.text(value) && !Validator.name(value)) {
        setErrors((prev) => ({
          ...prev,
          fullName: t("common.messages.error.common.fullName.inValid"),
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          fullName: "",
        }));
      }
    }

    if (name === "email") {
      if (!Validator.text(value)) {
        setErrors((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.blank"),
        }));
      } else if (Validator.text(value) && !Validator.email(value)) {
        setErrors((prev) => ({
          ...prev,
          email: t("common.messages.error.common.email.inValid"),
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          email: "",
        }));
      }
    }

    if (name === "reason") {
      if (!Validator.text(value)) {
        setErrors((prev) => ({
          ...prev,
          reason: t("common.messages.error.common.reason.blank"),
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          reason: "",
        }));
      }
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      if (
        Validator.text(fullName) &&
        Validator.name(fullName) &&
        Validator.text(email) &&
        Validator.email(email) &&
        Validator.text(reason)
      ) {
        resolve(true);
      } else {
        if (!Validator.text(fullName)) {
          setErrors((prev) => ({
            ...prev,
            fullName: t("common.messages.error.common.fullName.blank"),
          }));
        } else if (fullName && !Validator.name(fullName)) {
          setErrors((prev) => ({
            ...prev,
            fullName: t("common.messages.error.common.fullName.inValid"),
          }));
        }

        if (!Validator.text(email)) {
          setErrors((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.blank"),
          }));
        } else if (email && !Validator.email(email)) {
          setErrors((prev) => ({
            ...prev,
            email: t("common.messages.error.common.email.inValid"),
          }));
        }

        if (!Validator.text(reason)) {
          setErrors((prev) => ({
            ...prev,
            reason: t("common.messages.error.common.reason.blank"),
          }));
        }

        resolve(false);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        const payload = {
          fullname: fullName,
          email,
          organization: organizationName,
          phone,
          country,
          reason,
        };
        const response = await newAuthService(
          createContactUsUrl,
          "POST",
          payload
        );
        if (response.status) {
          toggle();
          toast.success(t("common.messages.notification.success.contactSales"));
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      }
    }
  };

  return (
    <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
      <Modal.Header closeButton className="px-5">
        <Modal.Title className="text-xl">Contact Us</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-5">
        <p className="text-muted mb-4">
          Fill in the form below for any queries. We will get back to you
          shortly.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="rounded-3 p-4 border border-grey-200 mb-4">
            <div className="mb-3">
              <label htmlFor="fullName" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="fullName"
                placeholder={t("common.placeHolder.fullName")}
                name="fullName"
                value={fullName}
                onChange={handleChange}
              />
              {errors.fullName && (
                <small className="text-danger">{errors.fullName}</small>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder={t("common.placeHolder.email")}
                name="email"
                value={email}
                onChange={handleChange}
              />
              {errors.email && (
                <small className="text-danger">{errors.email}</small>
              )}
            </div>

            <div className="mb-3">
              <label htmlFor="organizationName" className="form-label">
                Organization Name
              </label>
              <input
                type="text"
                className="form-control"
                id="organizationName"
                placeholder={t("common.placeHolder.organizationName")}
                name="organizationName"
                value={organizationName}
                onChange={handleChange}
              />
              {errors.organizationName && (
                <small className="text-danger">{errors.organizationName}</small>
              )}
            </div>

            <div className="row g-3">
              <div className="col-md-6">
                <label htmlFor="phone" className="form-label">
                  Phone No.
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="phone"
                  placeholder={t("common.placeHolder.phone")}
                  name="phone"
                  value={phone}
                  onChange={handleChange}
                />
                {errors.phone && (
                  <small className="text-danger">{errors.phone}</small>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="country" className="form-label">
                  Country
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="country"
                  placeholder={t("common.placeHolder.country")}
                  name="country"
                  value={country}
                  onChange={handleChange}
                />
                {errors.country && (
                  <small className="text-danger">{errors.country}</small>
                )}
              </div>
            </div>
          </div>

          <div className="mb-4">
            <label htmlFor="reason" className="form-label">
              Reason for Contact
            </label>
            <textarea
              className="form-control"
              id="reason"
              rows="3"
              placeholder={t("common.placeHolder.reason")}
              name="reason"
              value={reason}
              onChange={handleChange}
            ></textarea>
            {errors.reason && (
              <small className="text-danger">{errors.reason}</small>
            )}
          </div>

          <button type="submit" className="btn btn-primary px-4">
            Submit
          </button>
        </form>
      </Modal.Body>
    </Modal>
  );
};
